/* =========================
   PEGUU — CONFIGURA TU QR
========================= */

(function () {
  "use strict";


  /* =========================
     CONFIGURACIÓN
  ========================= */

  const STORAGE_KEY =
    "peguu:qr-config";

  const QR_RENDER_DELAY =
    180;

  /*
   * Los acabados Mate / Brillante
   * pertenecen a los materiales
   * normales de stickers.
   *
   * NO usar "qr_sticker", porque ese
   * corresponde al producto
   * "Calcomanía QR Matte".
   */

  const FINISH_PRODUCT_CODE =
    "sticker";


  /* =========================
     CONFIGURACIÓN DE ACABADOS
  ========================= */

  const FINISH_CONFIG = {

    mate: {
      label: "Mate",

      aliases: [
        "mate",
        "matte"
      ]
    },

    brillante: {
      label: "Brillante",

      aliases: [
        "brillante",
        "glossy",
        "gloss"
      ]
    }

  };


  /* =========================
     INICIALIZACIÓN
  ========================= */

  function initPeguuQrConfig() {

    const root =
      document.querySelector(
        "[data-peguu-qr-config]"
      );


    if (
      !root ||
      root.dataset.initialized ===
        "true"
    ) {
      return;
    }


    root.dataset.initialized =
      "true";


    /* =========================
       ELEMENTOS
    ========================= */

    const materialsApiUrl =
      window.PeguuApi.resolve(
        root.dataset.materialsApiUrl
      );


    const nextUrl =
      root.dataset.nextUrl ||
      "/pages/arma-tus-stickers";


    const finishInputs =
      Array.from(
        root.querySelectorAll(
          'input[name="qr-finish"]'
        )
      );


    const finishOptions =
      Array.from(
        root.querySelectorAll(
          "[data-finish-option]"
        )
      );


    const positionInputs =
      Array.from(
        root.querySelectorAll(
          'input[name="qr-position"]'
        )
      );


    const urlInput =
      root.querySelector(
        "#PeguuQrUrl"
      );


    const urlMessage =
      root.querySelector(
        "[data-qr-url-message]"
      );


    const qrPreviewImage =
      root.querySelector(
        "[data-qr-preview-image]"
      );


    const qrPreviewPlaceholder =
      root.querySelector(
        "[data-qr-preview-placeholder]"
      );


    const continueButton =
      root.querySelector(
        "[data-continue-button]"
      );


    const validationMessage =
      root.querySelector(
        "[data-qr-validation]"
      );


    const validationSummary =
      root.querySelector(
        "[data-qr-validation-summary]"
      );


    const validationList =
      root.querySelector(
        "[data-qr-validation-list]"
      );


    /* =========================
       ESTADO
    ========================= */

    const state = {

      finish: "",

      materialId: "",
      materialName: "",
      productCode: "",

      destinationUrl: "",

      acabado: "",
      posicion: ""

    };


    /* =========================
       CONTROL PREVIEW QR
    ========================= */

    let qrRenderTimer =
      null;

    let qrRenderRequest =
      0;


    let hasAttemptedContinue =
      false;


    /* =========================
       NORMALIZAR TEXTO
    ========================= */

    function normalizeText(
      value
    ) {

      return String(
        value || ""
      )
        .normalize(
          "NFD"
        )
        .replace(
          /[\u0300-\u036f]/g,
          ""
        )
        .trim()
        .toLowerCase();
    }


    /* =========================
       OBTENER PALABRAS
    ========================= */

    function getWords(
      value
    ) {

      return normalizeText(
        value
      )
        .split(
          /[^a-z0-9]+/
        )
        .filter(
          Boolean
        );
    }


    /* =========================
       DISTANCIA ENTRE PALABRAS
    ========================= */

    function getEditDistance(
      firstValue,
      secondValue
    ) {

      const first =
        normalizeText(
          firstValue
        );


      const second =
        normalizeText(
          secondValue
        );


      if (
        first === second
      ) {
        return 0;
      }


      if (
        !first.length
      ) {
        return second.length;
      }


      if (
        !second.length
      ) {
        return first.length;
      }


      const previousRow =
        Array.from(
          {
            length:
              second.length + 1
          },
          (
            _,
            index
          ) => index
        );


      for (
        let firstIndex = 1;
        firstIndex <= first.length;
        firstIndex += 1
      ) {

        const currentRow =
          [
            firstIndex
          ];


        for (
          let secondIndex = 1;
          secondIndex <= second.length;
          secondIndex += 1
        ) {

          const insertionCost =
            currentRow[
              secondIndex - 1
            ] + 1;


          const deletionCost =
            previousRow[
              secondIndex
            ] + 1;


          const substitutionCost =
            previousRow[
              secondIndex - 1
            ] +
            (
              first[
                firstIndex - 1
              ] ===
              second[
                secondIndex - 1
              ]
                ? 0
                : 1
            );


          currentRow[
            secondIndex
          ] =
            Math.min(
              insertionCost,
              deletionCost,
              substitutionCost
            );
        }


        for (
          let index = 0;
          index < currentRow.length;
          index += 1
        ) {

          previousRow[
            index
          ] =
            currentRow[
              index
            ];
        }
      }


      return previousRow[
        second.length
      ];
    }


    /* =========================
       VALIDAR ALIAS
    ========================= */

    function wordMatchesAlias(
      word,
      alias
    ) {

      const normalizedWord =
        normalizeText(
          word
        );


      const normalizedAlias =
        normalizeText(
          alias
        );


      if (
        !normalizedWord ||
        !normalizedAlias
      ) {
        return false;
      }


      /* COINCIDENCIA EXACTA */

      if (
        normalizedWord ===
        normalizedAlias
      ) {
        return true;
      }


      /*
       * Para palabras cortas exigimos
       * coincidencia exacta.
       *
       * Evita confundir:
       *
       * mate
       * material
       */

      if (
        normalizedAlias.length <
        5
      ) {
        return false;
      }


      /*
       * Para palabras largas permitimos
       * una diferencia de una letra.
       */

      return (
        getEditDistance(
          normalizedWord,
          normalizedAlias
        ) <= 1
      );
    }


    /* =========================
       VALIDAR ACABADO
    ========================= */

    function matchesFinish(
      materialName,
      finishKey
    ) {

      const finishConfig =
        FINISH_CONFIG[
          finishKey
        ];


      if (
        !finishConfig
      ) {
        return false;
      }


      const words =
        getWords(
          materialName
        );


      return words.some(
        (word) =>

          finishConfig.aliases.some(
            (alias) =>

              wordMatchesAlias(
                word,
                alias
              )
          )
      );
    }


    /* =========================
       STORAGE
    ========================= */

    function getStoredState() {

      try {

        const stored =
          sessionStorage.getItem(
            STORAGE_KEY
          );


        if (
          !stored
        ) {
          return null;
        }


        return JSON.parse(
          stored
        );


      } catch (
        error
      ) {

        console.warn(
          "Peguu QR: no se pudo leer el estado.",
          error
        );


        return null;
      }
    }


    function saveState() {

      try {

        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(
            state
          )
        );


      } catch (
        error
      ) {

        console.warn(
          "Peguu QR: no se pudo guardar el estado.",
          error
        );
      }


      document.dispatchEvent(
        new CustomEvent(
          "peguu:qr-config-updated",
          {
            detail: {

              ...state,

              isValid:
                isStepValid()

            }
          }
        )
      );
    }


    /* =========================
       EXTRAER MATERIALES API
    ========================= */

    function extractMaterials(
      result
    ) {

      if (
        Array.isArray(
          result
        )
      ) {
        return result;
      }


      if (
        Array.isArray(
          result?.data
        )
      ) {
        return result.data;
      }


      if (
        Array.isArray(
          result?.materials
        )
      ) {
        return result.materials;
      }


      if (
        Array.isArray(
          result?.items
        )
      ) {
        return result.items;
      }


      return [];
    }


    /* =========================
       VALIDAR MATERIAL DE ACABADO
    ========================= */

    function isFinishMaterial(
      material
    ) {

      return (
        normalizeText(
          material?.productCode
        ) ===
        FINISH_PRODUCT_CODE
      );
    }


    /* =========================
       BUSCAR ACABADO
    ========================= */

    function findFinishMaterial(
      materials,
      finishKey
    ) {

      return materials.find(
        (material) => {

          /* SOLO ACTIVOS */

          if (
            material?.active !==
            true
          ) {
            return false;
          }


          /*
           * SOLO STICKERS NORMALES.
           *
           * Excluye:
           *
           * productCode = qr_sticker
           *
           * Por lo tanto:
           *
           * "Calcomanía QR Matte"
           * nunca será utilizada aquí.
           */

          if (
            !isFinishMaterial(
              material
            )
          ) {
            return false;
          }


          return matchesFinish(
            material?.name,
            finishKey
          );
        }
      );
    }


    /* =========================
       LABEL DEL ACABADO
    ========================= */

    function getFinishLabel(
      finishKey
    ) {

      return (
        FINISH_CONFIG[
          finishKey
        ]?.label ||
        finishKey
      );
    }


    /* =========================
       OCULTAR IMAGEN
    ========================= */

    function hideImage(
      image
    ) {

      if (
        !image
      ) {
        return;
      }


      image.hidden =
        true;


      image.removeAttribute(
        "src"
      );
    }


    /* =========================
       RENDERIZAR ACABADO
    ========================= */

    function renderFinishMaterial(
      finishKey,
      material
    ) {

      const option =
        root.querySelector(
          `[data-finish-option="${finishKey}"]`
        );


      if (
        !option
      ) {
        return;
      }


      const input =
        option.querySelector(
          "[data-finish-input]"
        );


      const image =
        option.querySelector(
          "[data-finish-image]"
        );


      const placeholder =
        option.querySelector(
          "[data-finish-placeholder]"
        );


      const label =
        option.querySelector(
          "[data-finish-label]"
        );


      const finishLabel =
        getFinishLabel(
          finishKey
        );


      /* =========================
         LABEL
      ========================= */

      if (
        label
      ) {

        label.textContent =
          finishLabel;
      }


      /* =========================
         NO DISPONIBLE
      ========================= */

      if (
        !material
      ) {

        option.classList.add(
          "is-unavailable"
        );


        if (
          input
        ) {

          input.disabled =
            true;

          input.checked =
            false;


          delete input.dataset
            .materialId;

          delete input.dataset
            .materialName;

          delete input.dataset
            .productCode;
        }


        hideImage(
          image
        );


        if (
          placeholder
        ) {

          placeholder.hidden =
            false;

          placeholder.textContent =
            "No disponible";
        }


        return;
      }


      /* =========================
         DISPONIBLE
      ========================= */

      option.classList.remove(
        "is-unavailable"
      );


      if (
        input
      ) {

        input.disabled =
          false;


        input.dataset.materialId =
          String(
            material.id ?? ""
          );


        input.dataset.materialName =
          String(
            material.name || ""
          );


        input.dataset.productCode =
          String(
            material.productCode ||
            ""
          );
      }


      /* =========================
         IMAGEN REAL DE API
      ========================= */

      const imageUrl =
        String(
          material.imageUrl || ""
        ).trim();


      if (
        !image ||
        !imageUrl
      ) {

        hideImage(
          image
        );


        if (
          placeholder
        ) {

          placeholder.hidden =
            false;

          placeholder.textContent =
            finishLabel;
        }


        return;
      }


      image.onload =
        function () {

          image.hidden =
            false;


          if (
            placeholder
          ) {

            placeholder.hidden =
              true;
          }
        };


      image.onerror =
        function () {

          hideImage(
            image
          );


          if (
            placeholder
          ) {

            placeholder.hidden =
              false;

            placeholder.textContent =
              finishLabel;
          }
        };


      image.alt =
        material.name ||
        `Acabado ${finishLabel.toLowerCase()}`;


      image.src =
        imageUrl;
    }


    /* =========================
       ERROR CARGANDO MATERIALES
    ========================= */

    function setFinishLoadError() {

      finishOptions.forEach(
        (option) => {

          option.classList.add(
            "is-unavailable"
          );


          const input =
            option.querySelector(
              "[data-finish-input]"
            );


          const image =
            option.querySelector(
              "[data-finish-image]"
            );


          const placeholder =
            option.querySelector(
              "[data-finish-placeholder]"
            );


          if (
            input
          ) {

            input.disabled =
              true;

            input.checked =
              false;
          }


          hideImage(
            image
          );


          if (
            placeholder
          ) {

            placeholder.hidden =
              false;

            placeholder.textContent =
              "No disponible";
          }
        }
      );
    }


    /* =========================
       CARGAR MATERIALES API
    ========================= */

    async function loadFinishMaterials() {

      if (
        !materialsApiUrl
      ) {

        console.warn(
          "Peguu QR: no se configuró la API de materiales."
        );


        setFinishLoadError();

        return;
      }


      try {

        const materials =
          await window.PeguuMaterials.getMaterials({
            url: materialsApiUrl
          });


        /* =========================
           BUSCAR BRILLANTE
        ========================= */

        const brilliantMaterial =
          findFinishMaterial(
            materials,
            "brillante"
          );


        /* =========================
           BUSCAR MATE / MATTE
        ========================= */

        const matteMaterial =
          findFinishMaterial(
            materials,
            "mate"
          );


        renderFinishMaterial(
          "brillante",
          brilliantMaterial
        );


        renderFinishMaterial(
          "mate",
          matteMaterial
        );


      } catch (
        error
      ) {

        console.error(
          "Peguu QR: error al cargar los acabados.",
          error
        );


        setFinishLoadError();
      }
    }


    /* =========================
       NORMALIZAR URL
    ========================= */

    function normalizeDestinationUrl(
      value
    ) {

      const rawValue =
        String(
          value || ""
        ).trim();


      if (
        !rawValue
      ) {
        return "";
      }


      if (
        /^https?:\/\//i.test(
          rawValue
        )
      ) {

        return rawValue;
      }


      return (
        "https://" +
        rawValue
      );
    }


    /* =========================
       VALIDAR URL
    ========================= */

    function isValidUrl(
      value
    ) {

      const normalizedUrl =
        normalizeDestinationUrl(
          value
        );


      if (
        !normalizedUrl
      ) {
        return false;
      }


      try {

        const parsedUrl =
          new URL(
            normalizedUrl
          );


        const validProtocol =
          (
            parsedUrl.protocol ===
            "http:"
          ) ||
          (
            parsedUrl.protocol ===
            "https:"
          );


        if (
          !validProtocol
        ) {
          return false;
        }


        const hostname =
          parsedUrl.hostname;


        return Boolean(

          hostname.includes(
            "."
          ) ||

          hostname ===
            "localhost" ||

          /^\d{1,3}(\.\d{1,3}){3}$/.test(
            hostname
          )

        );


      } catch {

        return false;
      }
    }


    /* =========================
       MENSAJE URL
    ========================= */

    function updateUrlMessage() {

      if (
        !urlInput ||
        !urlMessage
      ) {
        return;
      }


      const rawValue =
        String(
          urlInput.value || ""
        ).trim();


      urlMessage.classList.remove(
        "is-error"
      );


      if (
        !rawValue
      ) {

        urlMessage.textContent =
          "";

        return;
      }


      if (
        isValidUrl(
          rawValue
        )
      ) {

        urlMessage.textContent =
          "Perfecto. Revisaremos tu enlace antes de imprimir.";

        return;
      }


      urlMessage.classList.add(
        "is-error"
      );


      urlMessage.textContent =
        "Ingresa una URL válida, por ejemplo: https://tusitio.com";
    }


    /* =========================
       OBTENER LIBRERÍA QR
    ========================= */

    function getQrCodeLibrary() {

      if (
        typeof globalThis !==
          "undefined" &&
        globalThis.QRCode &&
        typeof globalThis.QRCode
          .toDataURL ===
          "function"
      ) {

        return globalThis.QRCode;
      }


      if (
        typeof window !==
          "undefined" &&
        window.QRCode &&
        typeof window.QRCode
          .toDataURL ===
          "function"
      ) {

        return window.QRCode;
      }


      if (
        typeof QRCode !==
          "undefined" &&
        typeof QRCode.toDataURL ===
          "function"
      ) {

        return QRCode;
      }


      return null;
    }


    /* =========================
       LIMPIAR PREVIEW QR
    ========================= */

    function clearQrPreview() {

      qrRenderRequest +=
        1;


      if (
        qrRenderTimer
      ) {

        clearTimeout(
          qrRenderTimer
        );


        qrRenderTimer =
          null;
      }


      if (
        qrPreviewImage
      ) {

        qrPreviewImage.hidden =
          true;


        qrPreviewImage.removeAttribute(
          "src"
        );
      }


      if (
        qrPreviewPlaceholder
      ) {

        qrPreviewPlaceholder.hidden =
          false;
      }
    }


    /* =========================
       GENERAR QR
    ========================= */

    async function generateQrPreview(
      value
    ) {

      if (
        !qrPreviewImage ||
        !qrPreviewPlaceholder
      ) {
        return;
      }


      const qrCodeLibrary =
        getQrCodeLibrary();


      if (
        !qrCodeLibrary
      ) {

        console.error(
          "Peguu QR: qrcode.js no está disponible o no expone QRCode.toDataURL()."
        );


        clearQrPreview();

        return;
      }


      const requestId =
        ++qrRenderRequest;


      try {

        const dataUrl =
          await qrCodeLibrary
            .toDataURL(
              value,
              {

                width:
                  200,

                margin:
                  1,

                errorCorrectionLevel:
                  "M"

              }
            );


        /*
         * Ignorar respuestas anteriores
         * si el usuario ya cambió el valor.
         */

        if (
          requestId !==
          qrRenderRequest
        ) {
          return;
        }


        qrPreviewImage.src =
          dataUrl;


        qrPreviewImage.hidden =
          false;


        qrPreviewPlaceholder.hidden =
          true;


      } catch (
        error
      ) {

        console.error(
          "Peguu QR: no se pudo generar la vista previa.",
          error
        );


        if (
          requestId ===
          qrRenderRequest
        ) {

          clearQrPreview();
        }
      }
    }


    /* =========================
       PROGRAMAR PREVIEW
    ========================= */

    function scheduleQrPreview() {

      if (
        qrRenderTimer
      ) {

        clearTimeout(
          qrRenderTimer
        );


        qrRenderTimer =
          null;
      }


      const rawValue =
        String(
          urlInput?.value || ""
        ).trim();


      if (
        !rawValue
      ) {

        clearQrPreview();

        return;
      }


      const previewValue =
        isValidUrl(
          rawValue
        )
          ? normalizeDestinationUrl(
              rawValue
            )
          : rawValue;


      qrRenderTimer =
        setTimeout(
          () => {

            qrRenderTimer =
              null;


            generateQrPreview(
              previewValue
            );

          },
          QR_RENDER_DELAY
        );
    }


    /* =========================
       VALIDAR PASO
    ========================= */

    function isStepValid() {

      return Boolean(

        state.acabado &&

        state.materialId &&

        state.posicion &&

        isValidUrl(
          state.destinationUrl
        )

      );
    }


    /* =========================
       CAMPOS PENDIENTES
    ========================= */

    function getValidationIssues() {

      const issues = [];


      if (
        !state.acabado
      ) {

        issues.push({
          message:
            "Por favor, selecciona el acabado.",
          section:
            root.querySelector(
              ".peguu-qr-config__finish"
            ),
          control:
            finishInputs.find(
              (input) =>
                !input.disabled
            )
        });

      } else if (
        !state.materialId
      ) {

        issues.push({
          message:
            "Por favor, selecciona un acabado disponible.",
          section:
            root.querySelector(
              ".peguu-qr-config__finish"
            ),
          control:
            finishInputs.find(
              (input) =>
                !input.disabled
            )
        });

      }


      if (
        !isValidUrl(
          state.destinationUrl
        )
      ) {

        issues.push({
          message:
            "Por favor, ingresa una URL válida para configurar el QR.",
          section:
            root.querySelector(
              ".peguu-qr-config__url-column"
            ),
          control:
            urlInput
        });

      }


      if (
        !state.posicion
      ) {

        issues.push({
          message:
            "Por favor, selecciona la posición del QR.",
          section:
            root.querySelector(
              ".peguu-qr-config__position-column"
            ),
          control:
            positionInputs[0]
        });

      }


      return issues;
    }


    /* =========================
       MENSAJE DE VALIDACIÓN
    ========================= */

    function updateValidationMessage(
      focusFirstIssue = false
    ) {

      if (
        !validationMessage ||
        !validationSummary ||
        !validationList
      ) {
        return;
      }


      const issues =
        getValidationIssues();


      validationList.replaceChildren();


      if (
        !hasAttemptedContinue ||
        issues.length === 0
      ) {

        validationMessage.hidden =
          true;

        validationSummary.textContent =
          "";

        return;
      }


      validationSummary.textContent =
        issues.length > 1
          ? "Por favor, completa las selecciones pendientes para continuar."
          : issues[0].message;


      if (
        issues.length > 1
      ) {

        issues.forEach(
          (issue) => {

            const item =
              document.createElement(
                "li"
              );


            item.textContent =
              issue.message;


            validationList.append(
              item
            );

          }
        );

      }


      validationMessage.hidden =
        false;


      if (
        !focusFirstIssue
      ) {
        return;
      }


      const firstIssue =
        issues[0];


      firstIssue.section
        ?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });


      window.setTimeout(
        () => {

          firstIssue.control
            ?.focus({
              preventScroll: true
            });

        },
        350
      );
    }


    /* =========================
       ACTUALIZAR BOTÓN SIGUIENTE
    ========================= */

    function updateContinueButton(
      focusValidation = false
    ) {

      if (
        !continueButton
      ) {
        return;
      }


      const isValid =
        isStepValid();


      continueButton.disabled =
        false;


      continueButton.setAttribute(
        "aria-disabled",
        String(
          !isValid
        )
      );


      continueButton.classList.toggle(
        "is-disabled",
        !isValid
      );


      if (
        hasAttemptedContinue
      ) {

        updateValidationMessage(
          focusValidation
        );

      }
    }


    /* =========================
       SINCRONIZAR ESTADO
    ========================= */

    function syncStateFromForm(
      save = true
    ) {

      const selectedFinish =
        root.querySelector(
          'input[name="qr-finish"]:checked'
        );


      const selectedPosition =
        root.querySelector(
          'input[name="qr-position"]:checked'
        );


      /* =========================
         ACABADO
      ========================= */

      state.finish =
        selectedFinish?.value ||
        "";


      state.acabado =
        selectedFinish?.value ||
        "";


      /* =========================
         MATERIAL API
      ========================= */

      state.materialId =
        selectedFinish?.dataset
          .materialId ||
        "";


      state.materialName =
        selectedFinish?.dataset
          .materialName ||
        "";


      state.productCode =
        selectedFinish?.dataset
          .productCode ||
        "";


      /* =========================
         URL
      ========================= */

      state.destinationUrl =
        normalizeDestinationUrl(
          urlInput?.value
        );


      /* =========================
         POSICIÓN
      ========================= */

      state.posicion =
        selectedPosition?.value ||
        "";


      /* =========================
         BOTÓN
      ========================= */

      updateContinueButton();


      /* =========================
         STORAGE
      ========================= */

      if (
        save
      ) {

        saveState();
      }
    }


    /* =========================
       LIMPIAR SELECCIONES DOM
    ========================= */

    function clearSelections() {

      finishInputs.forEach(
        (input) => {

          input.checked =
            false;
        }
      );


      positionInputs.forEach(
        (input) => {

          input.checked =
            false;
        }
      );
    }


    /* =========================
       RESTAURAR ESTADO
    ========================= */

    function restoreState() {

      const storedState =
        getStoredState();


      /*
       * Siempre limpiar primero.
       *
       * Evita cualquier selección
       * predeterminada accidental.
       */

      clearSelections();


      /* =========================
         PRIMERA ENTRADA
      ========================= */

      if (
        !storedState
      ) {

        if (
          urlInput
        ) {

          urlInput.value =
            "";
        }


        syncStateFromForm(
          false
        );


        updateUrlMessage();

        clearQrPreview();

        updateContinueButton();

        return;
      }


      /* =========================
         RESTAURAR URL
      ========================= */

      const storedUrl =
        storedState.destinationUrl ||
        storedState.url ||
        "";


      if (
        urlInput &&
        typeof storedUrl ===
          "string"
      ) {

        urlInput.value =
          storedUrl;
      }


      /* =========================
         RESTAURAR ACABADO
      ========================= */

      const storedFinish =
        storedState.acabado ||
        storedState.finish ||
        "";


      if (
        storedFinish
      ) {

        const finishInput =
          finishInputs.find(
            (input) =>

              input.value ===
                storedFinish &&

              !input.disabled
          );


        if (
          finishInput
        ) {

          finishInput.checked =
            true;
        }
      }


      /* =========================
         RESTAURAR POSICIÓN
      ========================= */

      const storedPosition =
        storedState.posicion ||
        storedState.position ||
        "";


      if (
        storedPosition
      ) {

        const positionInput =
          positionInputs.find(
            (input) =>

              input.value ===
              storedPosition
          );


        if (
          positionInput
        ) {

          positionInput.checked =
            true;
        }
      }


      syncStateFromForm(
        true
      );


      updateUrlMessage();

      scheduleQrPreview();

      updateContinueButton();
    }


    /* =========================
       EVENTOS ACABADO
    ========================= */

    finishInputs.forEach(
      (input) => {

        input.addEventListener(
          "change",
          () => {

            syncStateFromForm(
              true
            );
          }
        );

      }
    );


    /* =========================
       EVENTOS POSICIÓN
    ========================= */

    positionInputs.forEach(
      (input) => {

        input.addEventListener(
          "change",
          () => {

            syncStateFromForm(
              true
            );
          }
        );

      }
    );


    /* =========================
       EVENTOS URL
    ========================= */

    if (
      urlInput
    ) {

      urlInput.addEventListener(
        "input",
        () => {

          syncStateFromForm(
            true
          );


          updateUrlMessage();

          scheduleQrPreview();

        }
      );


      urlInput.addEventListener(
        "blur",
        () => {

          syncStateFromForm(
            true
          );


          updateUrlMessage();

          scheduleQrPreview();

        }
      );
    }


    /* =========================
       BOTÓN SIGUIENTE
    ========================= */

    if (
      continueButton
    ) {

      continueButton.addEventListener(
        "click",
        () => {

          /*
           * Guardar nuevamente justo
           * antes de avanzar.
           */

          syncStateFromForm(
            true
          );


          /*
           * Protección adicional:
           *
           * aunque alguien intente
           * activar el botón manualmente,
           * no avanza si el paso
           * está incompleto.
           */

          if (
            !isStepValid()
          ) {

            hasAttemptedContinue =
              true;

            updateContinueButton(
              true
            );

            return;
          }


          /* =========================
             IR A MEDIDAS
          ========================= */

          window.location.assign(
            nextUrl
          );

        }
      );
    }


    /* =========================
       API PÚBLICA
    ========================= */

    window.PeguuQrConfig = {

      getState() {

        return {
          ...state
        };
      },


      getQrConfig() {

        return {

          destinationUrl:
            state.destinationUrl,

          acabado:
            state.acabado,

          posicion:
            state.posicion,

          materialId:
            state.materialId,

          materialName:
            state.materialName,

          productCode:
            state.productCode

        };
      },


      isValid() {

        return isStepValid();
      },


      refreshPreview() {

        scheduleQrPreview();
      },


      clear() {

        try {

          sessionStorage.removeItem(
            STORAGE_KEY
          );


        } catch (
          error
        ) {

          console.warn(
            "Peguu QR: no se pudo limpiar el estado.",
            error
          );
        }


        clearSelections();

        clearQrPreview();


        Object.assign(
          state,
          {

            finish: "",

            materialId: "",
            materialName: "",
            productCode: "",

            destinationUrl: "",

            acabado: "",
            posicion: ""

          }
        );


        if (
          urlInput
        ) {

          urlInput.value =
            "";
        }


        updateUrlMessage();

        updateContinueButton();
      }

    };


    /* =========================
       ESTADO INICIAL
    ========================= */

    clearSelections();

    updateContinueButton();


    /* =========================
       INICIAR
    ========================= */

    loadFinishMaterials()
      .then(
        () => {

          /*
           * Primero cargamos los materiales
           * disponibles.
           *
           * Después restauramos el estado
           * si el usuario está regresando
           * dentro del mismo flujo.
           */

          restoreState();

        }
      );

  }


  /* =========================
     DOM READY
  ========================= */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initPeguuQrConfig
    );


  } else {

    initPeguuQrConfig();
  }


  /* =========================
     SHOPIFY THEME EDITOR
  ========================= */

  document.addEventListener(
    "shopify:section:load",
    initPeguuQrConfig
  );

})();
